import BotonNav from "../components/BotonNav";
import NavBar from "../components/NavBar";
import Login from "../components/usuario/Login";

const Home = () => {
  return (
    <>
      <Login />
      <NavBar />
      <BotonNav />
    </>
  );
};

export default Home;
